import React from 'react';
import {
  OnePartnerSVG,
  EuropeanStandardsSVG,
  SustainabilitySVG,
  QualitySVG,
  CuratedNetworkSVG,
  TechTransparencySVG
} from './SVGs/WhySectionSVGs';

const WhySection = () => {
  const reasons = [
    { 
      icon: <OnePartnerSVG />, 
      title: 'One Partner. End-to-End Accountability', 
      desc: 'Supplier selection, engineering, QC, compliance, logistics, carbon visibility — all in one place.' 
    },
    { 
      icon: <EuropeanStandardsSVG />, 
      title: 'Built for European Standards', 
      desc: 'Aligned with ESG, CSRD, and European quality & regulatory expectations. Source globally without lowering your standards.' 
    },
    { 
      icon: <SustainabilitySVG />, 
      title: 'Sustainability Without Compromise', 
      desc: 'Removing intermediaries, optimizing flows, reducing emissions at the source — not offsetting them later.' 
    },
    { 
      icon: <QualitySVG />, 
      title: 'Quality You Can Verify', 
      desc: 'Engineering validation, in-house QC, on-site inspections, clear documentation. First sample (up to €50) is free.' 
    },
    { 
      icon: <CuratedNetworkSVG />, 
      title: 'A Curated Manufacturing Network', 
      desc: 'Limited pool of verified partners — capability, quality, ethics, continuity. Continuously evaluated through KPI-based tracking.' 
    },
    { 
      icon: <TechTransparencySVG />, 
      title: 'Technology-Enabled Transparency', 
      desc: 'Order tracking, centralized documentation, carbon reporting at order level. No black boxes. No surprises.' 
    },
  ];

  return (
    <section id="why" className="why-section">
      <div className="container">
        <div className="section-header">
          <span className="label">why procureforeu</span>
          <h2>Because Global Sourcing Needs a Better Model</h2>
          <p>Single accountable partner. Simplified procurement. Aligned with Europe's future.</p>
        </div>
        <div className="why-grid">
          {reasons.map((r, idx) => (
            <div key={idx} className="why-card">
              <div className="icon">
                {r.icon}
              </div>
              <h4>{r.title}</h4>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
        <div className="why-offer">
          <p><i className="fas fa-gem"></i> First sample up to €50 free · First carbon report free · No obligation. Just transparency.</p>
        </div>
      </div>
    </section>
  );
};

export default WhySection;